import React, { FC } from "react"
import styled from "styled-components"
import mobileImage from "../../../static/images/lp-lk-img-3.png"
import InputComponent from "../../../components/ui/input-form"

const BlockStyle = styled.div`
  background: #21a038;

  p,
  h2 {
    color: white;
  }

  p {
    font-size: 16px;
    line-height: 24px;
  }

  & > input {
    position: relative;
    top: -145px;
    z-index: 0;
    opacity: 0;
    width: 0;
    height: 0;

    @media screen and (max-width: 1023px) {
      top: -49px;
    }

    @media screen and (max-width: 575px) {
      top: -121px;
    }
  }
`

const StyledSubscription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1220px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 0;
    top: 5px;
  }

  @media screen and (max-width: 1023px) {
    padding: 40px 0 0 69px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 40px 20px 0;
  }
`

const FormStyle = styled.div`
  padding: 39px 20px;

  .promo-form__input {
    margin-top: 48px;

    &_mobile {
      padding: 0;
    }
  }

  @media screen and (min-width: 1024px) {
    width: 520px;
  }

  @media screen and (max-width: 1023px) {
    padding: 0;
    max-width: 522px;
  }
`

const Subscription: FC = () => {
  return (
    <BlockStyle>
      <input id="form-input" />
      <StyledSubscription>
        <FormStyle>
          <h2>Подпишитесь на уведомление о запуске</h2>
          <InputComponent className="promo-form__input_mobile" />
          <InputComponent className="promo-form__input" />
        </FormStyle>
        <div>
          <img src={mobileImage} alt="smartphone" />
        </div>
      </StyledSubscription>
    </BlockStyle>
  )
}

export default Subscription
